function checkSticky() {
  if (window.innerWidth <= 750) {
    jQuery(".hero-button-sticky").sticky({ zIndex: 100 });
  } else {
    jQuery(".hero-button-sticky").unstick();
  }
}

checkSticky();

window.addEventListener("resize", checkSticky);

document.addEventListener("shopify:block:select", (event) => {
  const editorBlock = JSON.parse(event.target.dataset.shopifyEditorBlock);

  if (editorBlock.type === "hero-button") {
    checkSticky();
  }
});
